
import { supabase } from '@/integrations/supabase/client';
import { toast } from "sonner";

export const setupCipherResultsTable = async () => {
  try {
    console.log("Setting up cipher_results table...");
    
    // Call the function to set up the table
    const { error: functionError } = await supabase.rpc('create_cipher_results_table');
    
    if (functionError) {
      console.error("Error setting up cipher_results table:", functionError);
      return false;
    }
    
    // Check if the table exists by trying to query it
    const { error: queryError } = await supabase
      .from('cipher_results')
      .select('id')
      .limit(1);
      
    if (queryError) {
      console.error("Error verifying cipher_results table:", queryError);
      return false;
    }
    
    console.log("cipher_results table is ready");
    return true;
  } catch (error) {
    console.error("Error setting up cipher_results table:", error);
    toast.error("Error initializing cipher database");
    return false;
  }
};

export const setupInitiatedBrosTable = async () => {
  try {
    console.log("Setting up initiated_bros table...");
    
    // Call the function to set up the table
    const { error: functionError } = await supabase.rpc('create_initiated_bros_table');
    
    if (functionError) {
      console.error("Error setting up initiated_bros table:", functionError);
      return false;
    }
    
    // Check if the table exists by trying to query it
    const { error: queryError } = await supabase
      .from('initiated_bros')
      .select('id')
      .limit(1);
      
    if (queryError && !queryError.message.includes('does not exist')) {
      console.log("initiated_bros table exists but has no rows");
      return true;
    } else if (queryError) {
      console.error("Error verifying initiated_bros table:", queryError);
      return false;
    }
    
    console.log("initiated_bros table is ready");
    return true;
  } catch (error) {
    console.error("Error setting up initiated_bros table:", error);
    toast.error("Error initializing bros database");
    return false;
  }
};
